// src/hocs/withLayout.js
import React from "react";
import { Grid, Box } from "@mui/material";
import Topbar from "../scenes/global/Topbar";
import Sidebar from "../scenes/global/Sidebar";
import { DashboardNotificationsProvider } from "../context/DashboardNotificationsContext";
import NotificationBannerStack from "./DashboardNotifications/NotificationBannerStack";
import NotificationModal from "./DashboardNotifications/NotificationModal";
import NotificationToastContainer from "./DashboardNotifications/NotificationToastContainer";

const withLayout = (Component) => (props) =>
  (
    <DashboardNotificationsProvider>
      <Grid
        container
        wrap="nowrap"
        sx={{
          height: "100vh",
          maxHeight: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Grid
          item
          sx={{
            height: "100vh",
            maxHeight: "100vh",
            flexShrink: 0,
            alignSelf: "flex-start",
            overflow: "hidden",
          }}
        >
          <Sidebar />
        </Grid>
        <Grid
          item
          xs
          sx={{
            height: "100vh",
            maxHeight: "100vh",
            minWidth: 0,
            maxWidth: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box sx={{ flexShrink: 0, zIndex: 10 }}>
            <Topbar />
            <NotificationBannerStack />
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              maxWidth: "100%",
              overflowY: "auto",
              overflowX: "hidden",
              overscrollBehavior: "contain",
            }}
          >
            <Component {...props} />
          </Box>
        </Grid>
      </Grid>
      <NotificationModal />
      <NotificationToastContainer />
    </DashboardNotificationsProvider>
  );

export default withLayout;
